import React, { createContext, useContext } from 'react';
import { useNetworkResilience } from '../hooks/useNetworkResilience';

type NetworkResilienceType = ReturnType<typeof useNetworkResilience>;

export const NetworkResilienceContext = createContext<NetworkResilienceType | undefined>(undefined);

interface NetworkResilienceProviderProps {
  sessionId?: string;
  children: React.ReactNode;
}

export const NetworkResilienceProvider: React.FC<NetworkResilienceProviderProps> = ({
  sessionId,
  children,
}) => {
  const value = useNetworkResilience(sessionId);

  return (
    <NetworkResilienceContext.Provider value={value}>
      {children}
    </NetworkResilienceContext.Provider>
  );
};

export const useNetworkResilienceContext = () => {
  const context = useContext(NetworkResilienceContext);
  if (!context) {
    throw new Error(
      'useNetworkResilienceContext must be used within a NetworkResilienceProvider'
    );
  }
  return context;
};
